import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CustomValuesService } from '@core/services/custom-values.service';
import { EDeliverableType } from '@enums/campaign.enum';
import { TranslateModule } from '@ngx-translate/core';
import { AnalyticsStatusBadgeComponent } from '@shared/components/analytics-status-badge/analytics-status-badge.component';
import { CustomRemoveButtonComponent } from '@shared/components/custom-remove-button/custom-remove-button.component';
import { EditableTitleComponent } from '@shared/components/editable-title/editable-title.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { MatErrorComponent } from '@shared/components/mat-error/mat-error.component';
import { DeliverableAdvancedButtonComponent } from '../advanced-button/deliverable-advanced-button.component';
import { DeliverableAdvancedSettingsSectionComponent } from '../advanced-settings-section/deliverable-advanced-settings-section.component';
import { TextDescriptionDeliverableComponent } from '../shared/text-description-deliverable/text-description-deliverable.component';
import { TTextDescriptionDeliverableConfigOverrides } from '../shared/text-description-deliverable/text-description-deliverable.interface';

@Component({
  imports: [
    DeliverableAdvancedButtonComponent,
    DeliverableAdvancedSettingsSectionComponent,
    AnalyticsStatusBadgeComponent,
    CustomRemoveButtonComponent,
    EditableTitleComponent,
    IconComponent,
    MatButtonModule,
    MatCheckboxModule,
    MatErrorComponent,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  selector: 'app-talking-point-ai',
  templateUrl: '../shared/text-description-deliverable/text-description-deliverable.component.html',
})
export class TalkingPointAiComponent extends TextDescriptionDeliverableComponent {
  constructor(customValuesService: CustomValuesService) {
    super(customValuesService);
  }

  protected getConfigOverrides(): TTextDescriptionDeliverableConfigOverrides {
    return {
      highlightNamespace: 'talkingPointAi',
      placeholderTranslationKey:
        'pages.campaignForm.ctaDialog.ctaDetails.deliverables.talkingPointAiDeliverable.placeholder',
      subtitleTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.talkingPointAiDeliverable.subtitle',
      type: EDeliverableType.talkingPointAi,
    };
  }
}
